import type { ProductReturn } from '~/api/seller-after-sales/types'

export function isOneWay(productReturn: ProductReturn) {
  return (
    productReturn.kind === 'CUSTOMER_TO_SELLER' ||
    productReturn.kind === 'CUSTOMER_TO_REPAIR_FACTORY'
  )
}
